import React from 'react'

const SelectYear = () => {
  return (
  <div className='select-year'>
    <div className='arrow-left'></div>
    <span>2018</span>
    <div className='arrow-right'></div>
  </div>
  )
}

export default SelectYear


// WEBPACK FOOTER //
// ./src/components/SelectYear/SelectYear.js